import { merge } from 'lodash'
const API_URL = {
  getAPIUrl,
  getEnv
}
export default API_URL

const defaultConfig = {
  host: 'api.alianza.com',
  port: 443,
  protocol: 'https',
  version: 'v2'
}

function getAPIUrl (override) {
  const apiConfig = getApiConfig(override)
  return `${apiConfig.protocol}://${apiConfig.host}:${apiConfig.port}/${apiConfig.version}/`
}

function getApiConfig (override) {
  return merge({}, defaultConfig, window.serverConfig || {}, override)
}

function getEnv (override = undefined) {
  const apiConfig = getApiConfig(override)
  switch (apiConfig.host) {
    case 'api.d2.alianza.com':
      return 'dev'
    case 'api.q2.alianza.com':
      return 'qa'
    case 'api.b2.alianza.com':
      return 'beta'
    case 'api.alianza.com':
      return 'production'
    default:
      return 'dev'
  }
}



// WEBPACK FOOTER //
// ./src/lib/apiUrl/apiUrl.js